import { createContext, useContext, type ReactNode } from 'react';

const EntityAdminHeaderLayoutContext = createContext(false);

/** Presence of this provider means EntityAdmin is in a Spaces panel. */
export function EntityAdminHeaderLayoutProvider({ children }: { children: ReactNode }) {
  return <EntityAdminHeaderLayoutContext.Provider value={true}>{children}</EntityAdminHeaderLayoutContext.Provider>;
}

export function useEntityAdminHeaderLayout() {
  return { isPanelLayout: useContext(EntityAdminHeaderLayoutContext) };
}
